<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
}
</script>

<style lang="scss">
html,
body,
#app {
  margin: 0;
  padding: 0;
  overflow: hidden;
}

@font-face {
  font-family: electronicFont;
  src: url(@/assets/font/DS-DIGIT.TTF);
}

@font-face {
  font-family: syst;
  src: url(@/assets/font/syst.otf);
}

@font-face {
  font-family: syht;
  src: url(@/assets/font/syht.otf);
}

@font-face {
  font-family: fzxbs;
  src: url(@/assets/font/4084_方正大标宋_GBK.TTF);
}

@keyframes rotate1 {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }

  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@keyframes rotate2 {
  from {
    transform: translate(-50%, -50%) rotate(360deg);
  }

  to {
    transform: translate(-50%, -50%) rotate(0deg);
  }
}

ul {
  list-style: none;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: syst;
}

body {
  background: url(@/assets/images/bg.jpg) no-repeat top center;
  line-height: 1.15;
}
</style>